import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=3b77ff32&"
import script from "./remark.vue?vue&type=script&lang=ts&"
export * from "./remark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports